<template>
  <div id="app">
    <!-- <Nav /> -->
    <router-view />
    <Footer />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import { mapActions } from "vuex";

// import Nav from './components/Nav.vue';
import Footer from './components/Footer.vue';

export default {
  components: {
    // Nav, 
    Footer,
  },
  created() {
    window.addEventListener('resize', debounce(this.handleResize, 100));
  },
  async mounted() {
    this.handleResize();
    
    // get data
    try {
      await this.getLeaObj();
    } catch {
      console.log('oops')
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },  
  methods: {
    ...mapActions(['getLeaObj', 'setWidth']),
    handleResize() {
      const width = window.innerWidth;
      this.setWidth(width);
    },
  },
}
</script>

